export default __webpack_public_path__ + "static/media/team1.0f5d1dfe.jpeg";